import React from 'react';

export default function ContentUsagePolicy() {
  return (
    <div className="bg-white min-h-screen flex flex-col py-10 px-2">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-xl border border-gray-200 p-8">

        <h1 className="text-3xl font-bold text-purple-600 mb-6 text-center">
          Content Usage Policy
        </h1>

        <p className="text-gray-700 mb-8">
          This policy governs the usage, ownership, distribution, and protection of all content published inside Million2Trillion (M2T) by both platform and users.
        </p>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">
          Platform Intellectual Property
        </h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>All logos, designs, user interface components, software code, internal technology, and platform structures are fully owned by M2T Global Technologies.</li>
          <li>Unauthorized copying, duplication, modification, or reverse engineering of the M2T platform is strictly prohibited and protected by international copyright laws.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">
          User Content Ownership
        </h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>Users maintain full ownership of original educational content, strategies, trading signals, blog posts, or analysis shared on M2T.</li>
          <li>By publishing content, users grant M2T a royalty-free license to display, distribute, promote, or showcase their content within platform operations.</li>
          <li>Users are responsible for ensuring they have legal rights to publish any content submitted.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">
          External Distribution &amp; Republishing
        </h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>Without written permission, no third-party may download, reproduce, or redistribute any content displayed on M2T for commercial reuse.</li>
          <li>Screen capture, recording, or scraping platform data without consent violates platform intellectual property rights.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">
          Student Course Material Rights
        </h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>Students purchasing online courses or training programs receive personal non-transferable access for learning purposes only.</li>
          <li>Redistributing paid course content externally will result in permanent suspension of both student and instructor accounts.</li>
        </ul>

        <p className="text-gray-500 italic mt-10">
          Protecting verified content creators protects the verified financial market community. Content theft, piracy, or intellectual property violation will not be tolerated.
        </p>
      </div>
    </div>
  );
}
